import 'react';
import styled, { withTheme } from 'styled-components';
import { ThemeNames } from '@lendi-ui/commons/utils';
import { heading, body, Link } from '@lendi-ui/typography';
import getColour from '@lendi-ui/commons/colours';
import { container } from '@lendi-ui/container';
import { p, mt } from '@lendi-ui/spacing';
import { normalise } from '@lendi-ui/utils';
import { jsxs, jsx } from 'react/jsx-runtime';

function _toPrimitive(input, hint) {
  if (typeof input !== "object" || input === null) return input;
  var prim = input[Symbol.toPrimitive];
  if (prim !== undefined) {
    var res = prim.call(input, hint || "default");
    if (typeof res !== "object") return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (hint === "string" ? String : Number)(input);
}

function _toPropertyKey(arg) {
  var key = _toPrimitive(arg, "string");
  return typeof key === "symbol" ? key : String(key);
}

function _defineProperty(obj, key, value) {
  key = _toPropertyKey(key);
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}

var Wrapper = styled.div.withConfig({
  displayName: "indexstyle__Wrapper",
  componentId: "lui__sc-vlzqlo-0"
})(["", ";background-color:", ";"], normalise, () => getColour('background', 'container'));
var ContentContainer = styled.div.withConfig({
  displayName: "indexstyle__ContentContainer",
  componentId: "lui__sc-vlzqlo-1"
})(["", " height:100%;", ";"], container(), p('md'));
var LegalHeading = styled.h3.withConfig({
  displayName: "indexstyle__LegalHeading",
  componentId: "lui__sc-vlzqlo-2"
})(["", ";", ";color:", ";"], () => heading({
  size: 'md'
}), mt('sm'), () => getColour('text', 'main'));
var LegalParagraph = styled.p.withConfig({
  displayName: "indexstyle__LegalParagraph",
  componentId: "lui__sc-vlzqlo-3"
})(["", ";", ";color:", ";"], () => body({
  size: 'xs'
}), mt('md'), () => getColour('text', 'subtle'));

var DomainLegal = props => {
  var currentYear = new Date().getFullYear();
  return /*#__PURE__*/jsxs(Wrapper, _objectSpread2(_objectSpread2({}, props), {}, {
    "data-testid": "domain-legal",
    children: [/*#__PURE__*/jsxs(ContentContainer, {
      children: [/*#__PURE__*/jsx(LegalParagraph, {
        children: /*#__PURE__*/jsx("strong", {
          children: "What does an introductory rate mean?"
        })
      }), /*#__PURE__*/jsx(LegalParagraph, {
        children: "An introductory rate is a promotional interest rate that lenders use to attract new customers. It is sometimes referred to as a \u2018honeymoon rate\u2019. An introductory rate is only for a limited period of time, typically 12 months, after which the interest rate on the loan typically rises and reverts to the lender\u2019s standard variable interest rate."
      }), /*#__PURE__*/jsx(LegalParagraph, {
        children: /*#__PURE__*/jsx("strong", {
          children: "Comparison rates"
        })
      }), /*#__PURE__*/jsxs(LegalParagraph, {
        children: ["Comparison rates are based on a home loan of $150,000 for 25 years. ", /*#__PURE__*/jsx("strong", {
          children: "WARNING:"
        }), " The comparison rate is true only for the example given and may not include all fees and charges. Different terms, fees or other loan amounts might result in a different comparison rate."]
      }), /*#__PURE__*/jsxs(LegalParagraph, {
        children: [/*#__PURE__*/jsx("strong", {
          children: "IMPORTANT INFORMATION:"
        }), " Any information provided does not constitute an offer of credit and are examples of what may be available to you based on the information available. It does not take into account any product features or any applicable fees. Lending criteria and the basis upon which we assess what you may be able to afford may change at any time without notice. For Fixed Rate home loans, break costs may be payable which can be significant if you change the whole or part of your fixed rate loan or where additional or early repayments are made during the fixed rate period."]
      }), /*#__PURE__*/jsx(LegalParagraph, {
        children: "All applications are subject to lender assessment and approval. Cashback offers may be provided by some lenders and may only be available for particular products, terms and conditions apply."
      }), /*#__PURE__*/jsxs(LegalParagraph, {
        children: ["We are committed to protecting customer privacy and do not sell customer information, please refer to our", /*#__PURE__*/jsx(Link, {
          target: "_blank",
          href: "https://www.domain.com.au/home-loans/privacy/",
          children: /*#__PURE__*/jsx("span", {
            children: " Privacy Policy "
          })
        }), "for more information."]
      }), /*#__PURE__*/jsxs(LegalParagraph, {
        children: ["\xA9 ", /*#__PURE__*/jsx("span", {
          className: "curYear",
          children: currentYear
        }), " Digital Home Loans Pty Ltd ACN 619 694 156, a credit representative of Auscred Services Pty Ltd ACN 164 638 171 Australian Credit Licence 442372."]
      }), /*#__PURE__*/jsx(LegalParagraph, {
        children: "Domain Home Loans is the trading name of Digital Home Loans Pty Ltd ACN 619 694 156. Domain Home Loans is a joint venture between Domain Holdings Australia Limited and Auscred Pty Ltd. We compare thousands of home loans from over 25 leading lenders."
      }), /*#__PURE__*/jsx(LegalParagraph, {
        children: "Digital Home Loans Pty Ltd | Level 5, 100 Harris Street, Pyrmont NSW 2009"
      })]
    }), /*#__PURE__*/jsx("meta", {
      name: "format-detection",
      content: "telephone=no"
    })]
  }));
};

var LendiLegal = props => {
  var currentYear = new Date().getFullYear();
  return /*#__PURE__*/jsxs(Wrapper, _objectSpread2(_objectSpread2({}, props), {}, {
    "data-testid": "lendi-legal",
    children: [/*#__PURE__*/jsxs(ContentContainer, {
      children: [/*#__PURE__*/jsx(LegalHeading, {
        children: "Important legal stuff"
      }), /*#__PURE__*/jsx(LegalParagraph, {
        children: /*#__PURE__*/jsx("strong", {
          children: "What does an introductory rate mean?"
        })
      }), /*#__PURE__*/jsx(LegalParagraph, {
        children: "An introductory rate is a promotional interest rate that lenders use to attract new customers. It is sometimes referred to as a \u2018honeymoon rate\u2019. An introductory rate is only for a limited period of time, typically 12 months, after which the interest rate on the loan typically rises and reverts to the lender\u2019s standard variable interest rate."
      }), /*#__PURE__*/jsx(LegalParagraph, {
        children: /*#__PURE__*/jsx("strong", {
          children: "Comparison rates"
        })
      }), /*#__PURE__*/jsxs(LegalParagraph, {
        children: ["Comparison rates above are based on a home loan of $150,000 for 25 years. ", /*#__PURE__*/jsx("strong", {
          children: "WARNING:"
        }), " The comparison rates are true for the example given only and may not include all fees and charges. Different terms, fees or loan amounts might result in a different comparison rate."]
      }), /*#__PURE__*/jsxs(LegalParagraph, {
        children: [/*#__PURE__*/jsx("strong", {
          children: "IMPORTANT INFORMATION:"
        }), " Any information provided does not constitute an offer of credit and are examples of what may be available to you based on the information available. It does not take into account any product features or any applicable fees. Lending criteria and the basis upon which we assess what you may be able to afford may change at any time without notice. Top rates include lenders who are on our panel and are then defined by the circumstances provided by the borrower. For Fixed Rate home loans, break costs may be payable which can be significant if you change the whole or part of your fixed rate loan or where additional or early repayments are made during the fixed rate period."]
      }), /*#__PURE__*/jsx(LegalParagraph, {
        children: "All applications are subject to lender assessment and approval. Cashback offers may be provided by some lenders and may only be available for particular products, terms and conditions apply."
      }), /*#__PURE__*/jsxs(LegalParagraph, {
        children: ["We are committed to protecting customer privacy and do not sell customer information, please refer to our", /*#__PURE__*/jsx(Link, {
          target: "_blank",
          href: "https://www.lendi.com.au/about-us/privacy-policy/",
          children: /*#__PURE__*/jsx("span", {
            children: " Privacy Policy "
          })
        }), "for more information."]
      }), /*#__PURE__*/jsx(LegalParagraph, {
        children: "Our mission is to change the way Australians get home loans by providing a faster, smarter and more secure home loan experience designed around the customer\u2019s convenience and needs. We compare thousands of home loans from over 25 leading lenders."
      }), /*#__PURE__*/jsxs(LegalParagraph, {
        children: ["\xA9 ", /*#__PURE__*/jsx("span", {
          className: "curYear",
          children: currentYear
        }), " Lendi Pty Ltd ACN 611 161 856, a related body corporate of Auscred Services Pty Ltd ACN 164 638 171, Australian Credit Licence 442372."]
      }), /*#__PURE__*/jsx(LegalParagraph, {
        children: "Lendi Group Pty Ltd, which is the ultimate holding company of the Aussie and Lendi businesses, is owned by numerous shareholders including banks such as CBA, 1835i (ANZ\u2019s external venture capital partner) and Macquarie Bank, the Lendi founders and employees, and a number of Australian institutional investors and sophisticated investors including UniSuper."
      }), /*#__PURE__*/jsxs(LegalParagraph, {
        children: ["Made with love at Circular Quay in Sydney, Australia. \xA9 ", /*#__PURE__*/jsx("span", {
          className: "curYear",
          children: currentYear
        }), ". All rights reserved."]
      })]
    }), /*#__PURE__*/jsx("meta", {
      name: "format-detection",
      content: "telephone=no"
    })]
  }));
};

var AussieLegal = props => {
  var currentYear = new Date().getFullYear();
  return /*#__PURE__*/jsxs(Wrapper, _objectSpread2(_objectSpread2({}, props), {}, {
    "data-testid": "aussie-legal",
    children: [/*#__PURE__*/jsxs(ContentContainer, {
      children: [/*#__PURE__*/jsx(LegalHeading, {
        children: "Important legal stuff"
      }), /*#__PURE__*/jsx(LegalParagraph, {
        children: /*#__PURE__*/jsx("strong", {
          children: "What does an introductory rate mean?"
        })
      }), /*#__PURE__*/jsx(LegalParagraph, {
        children: "An introductory rate is a promotional interest rate that lenders use to attract new customers. It is sometimes referred to as a \u2018honeymoon rate\u2019. An introductory rate is only for a limited period of time, typically 12 months, after which the interest rate on the loan typically rises and reverts to the lender\u2019s standard variable interest rate."
      }), /*#__PURE__*/jsx(LegalParagraph, {
        children: /*#__PURE__*/jsx("strong", {
          children: "Comparison rates"
        })
      }), /*#__PURE__*/jsxs(LegalParagraph, {
        children: ["Comparison rates above are based on a home loan of $150,000 for 25 years. ", /*#__PURE__*/jsx("strong", {
          children: "WARNING:"
        }), " The comparison rates are true for the example given only and may not include all fees and charges. Different terms, fees or loan amounts might result in a different comparison rate."]
      }), /*#__PURE__*/jsxs(LegalParagraph, {
        children: [/*#__PURE__*/jsx("strong", {
          children: "IMPORTANT INFORMATION:"
        }), " Any information provided does not constitute an offer of credit and are examples of what may be available to you based on the information available. It does not take into account any product features or any applicable fees. Lending criteria and the basis upon which we assess what you may be able to afford may change at any time without notice. For Fixed Rate home loans, break costs may be payable which can be significant if you change the whole or part of your fixed rate loan or where additional or early repayments are made during the fixed rate period."]
      }), /*#__PURE__*/jsx(LegalParagraph, {
        children: "All applications are subject to lender assessment and approval. Cashback offers may be provided by some lenders and may only be available for particular products, terms and conditions apply."
      }), /*#__PURE__*/jsxs(LegalParagraph, {
        children: ["We are committed to protecting customer privacy and do not sell customer information, please refer to our", /*#__PURE__*/jsx(Link, {
          target: "_blank",
          href: "https://www.aussie.com.au/get-in-touch/speak-with-us/privacy.html?cid=010507",
          children: /*#__PURE__*/jsx("span", {
            children: " Privacy Policy "
          })
        }), "for more information."]
      }), /*#__PURE__*/jsx(LegalParagraph, {
        children: "Our mission is to help Aussies reach their property goals faster. We can compare thousands of home loans from over 25 leading lenders."
      }), /*#__PURE__*/jsxs(LegalParagraph, {
        children: ["\xA9 ", /*#__PURE__*/jsx("span", {
          className: "curYear",
          children: currentYear
        }), " AHL Investments Pty Ltd ABN 27 105 265 861 Australian Credit Licence 246786. Lendi Group Pty Ltd, which is the ultimate holding company of the Aussie and Lendi businesses, is owned by numerous shareholders including banks such as CBA, 1835i (ANZ\u2019s external venture capital partner) and Macquarie Bank, the Lendi founders and employees, and a number of Australian institutional investors and sophisticated investors, including UniSuper."]
      }), /*#__PURE__*/jsx(LegalParagraph, {
        children: "AHL Investments Pty Ltd | Level 28, Grosvenor Place, 225 George Street, Sydney NSW 2000"
      })]
    }), /*#__PURE__*/jsx("meta", {
      name: "format-detection",
      content: "telephone=no"
    })]
  }));
};

var Legal = props => {
  var {
    theme
  } = props;
  // theme.name is how we will be detecting theme in the future
  switch (theme === null || theme === void 0 ? void 0 : theme.name) {
    case ThemeNames.Lendi || ThemeNames.LendiNext:
      return /*#__PURE__*/jsx(LendiLegal, _objectSpread2({}, props));
    case ThemeNames.Domain:
      return /*#__PURE__*/jsx(DomainLegal, _objectSpread2({}, props));
    case ThemeNames.Aussie:
      return /*#__PURE__*/jsx(AussieLegal, _objectSpread2({}, props));
  }

  // theme.logo.logoName is backwards compatibility, to be removed in the next major
  switch (theme === null || theme === void 0 ? void 0 : theme.logo.logoName) {
    case 'LendiLogo':
      return /*#__PURE__*/jsx(LendiLegal, _objectSpread2({}, props));
    case 'DomainLogo':
      return /*#__PURE__*/jsx(DomainLegal, _objectSpread2({}, props));
  }
  return /*#__PURE__*/jsx(LendiLegal, {});
};
var index = withTheme(Legal);

export { index as default };
